import { Button, message } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { DownloadOutlined } from '@ant-design/icons';

function GetInventoryOrderButton({ orderId, getInventoryOrder, className, title = "Download" }) {
  const dispatch = useDispatch();

  const handleDownload = useCallback(() => {
    dispatch(getInventoryOrder(orderId)).catch((error) => {
      message.error(error.errors[0].message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <Button
      size="small"
      className={className}
      onClick={handleDownload}
      type="primary"
      icon={<DownloadOutlined />}
    >
      {title}
    </Button>
  );
}

export default React.memo(GetInventoryOrderButton);
